import { render } from "./MetawebInvalidRelationshipsDialog.vue?vue&type=template&id=a2c4cf48&ts=true"
import script from "./MetawebInvalidRelationshipsDialog.vue?vue&type=script&lang=ts"
export * from "./MetawebInvalidRelationshipsDialog.vue?vue&type=script&lang=ts"

import "./MetawebInvalidRelationshipsDialog.vue?vue&type=style&index=0&id=a2c4cf48&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__